'use strict';

(function () {
    'use strict';

    angular.module('schedules', ['schedules.closedSlot', 'ui.router', 'common']);
})();